<template>
    <div>
        <ModuleHeader :moduleName="text.login"/>
        <div class="content-container">
            <p class="explication-text">{{ text.explicationText }}</p>
            <div class="inputs">
                <BMTextInput :label="text.email" type="text" v-model="email"/>
                <BMTextInput v-if="$appInfo.authMode == 'mail-password'" :label="text.password" type="password" v-model="password"/>
            </div>
            <div class="buttons">
                <BMButton @is-clicked="login">{{ text.connect }}</BMButton>
            </div>
            <!-- <LangSelector/> -->
        </div>
    </div>
</template>

<script>
import ModuleHeader from '@/components/ModuleHeader'
import BMTextInput from '@/components/BlackMoonUI/BMTextInput'
import BMButton from '@/components/BlackMoonUI/BMButton'
import LangSelector from '@/components/LangSelector'

export default {
    components: {
        ModuleHeader,
        BMTextInput,
        BMButton,
        LangSelector
    },
    data(){
        return {
            email: '',
            password: ''
        }
    },
    computed: {
        text(){
            return this.$texts[this.$i18n.locale].login
        }
    },
    methods: {
        test(){
            console.log('test')
        },
        async login(){
            console.log('login')
            const { data } = await this.$axios.post(`https://user.service.blackmoonlab.net/${this.$appInfo.name}/login-mail-phone`, {
                credentials: {
                    login: this.email
                }
            })
            console.log(data)
            if(data == 'Invalid credentials'){
                window.alert('Email invalide')
            }
            else {
                localStorage.setItem('auth-token', data.token)
                this.$sharedStore.set('user_id', data.id)
                this.$sharedStore.set('firstname', data.firstname)
                this.$sharedStore.set('lastname', data.lastname)
                this.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
                this.$router.push('/')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .explication-text {
        text-align: center;
        padding: 4vw;
        font-size: 12px;
        opacity: 0;
    }

    .inputs {
        padding: vh(4);
    }

    .buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
</style>